export const WARP_ME_EXTERNAL_LINKS = {
  consumerSite: "https://warpme.jp",
  corporateSite: "https://lp.warpme.jp",
  support: {
    consumerFaq: "https://lp.warpme.jp/faq/",
    tenantFaq: "https://lp.warpme.jp/help/",
    company: "https://lp.warpme.jp/company/",
    contact: "https://lp.warpme.jp/#contact-form",
  },
  legal: {
    consumerTerms: "https://lp.warpme.jp/terms-user/",
    tenantTerms: "https://lp.warpme.jp/terms-merchant/",
    privacyPolicy: "https://lp.warpme.jp/privacy-policy/",
    specifiedCommercialTransactions: "https://lp.warpme.jp/specified-commercial-transactions/",
  },
  tenant: {
    planChange: "https://lp.warpme.jp/plan/",
  },
} as const
